import { render } from "./Swiper.vue?vue&type=template&id=ce2c106c&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=ce2c106c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\34222\\Desktop\\kuaiyingyong\\vue-deom1\\官网\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2c106c"]])

export default __exports__